const directiveName = 'ltValidateEmail';
const directive = [() => {

	const EMAIL_REGEXP = /^[\w.+-]+@[\w.-]+\.[a-zA-Z]{2,7}$/;

	return {
		require: 'ngModel',
		link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes, ctrl: ng.INgModelController) => {

			ctrl.$validators.email = (modelValue: string, viewValue: string) => {
				return ctrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
			};

		}
	} as ng.IDirective<ng.IScope, ng.IAugmentedJQuery, ng.IAttributes, ng.INgModelController>;
}];

export default function(module: ng.IModule): void {
	module.directive(directiveName, directive);
}
